import type {
  TPropertyWildCardData,
  TStandardPropertyCard,
} from '@kapitalist/contract/types'
import {createUnsafe, type NEList} from '@kapitalist/utils/NEList'
import {allStandardPropertyTypes} from '~/game/types'
import SpecialPropertyCard from '~/models/game/Cards/SpecialPropertyCard'

export default class PropertyWildCard extends SpecialPropertyCard<TPropertyWildCardData> {
  public value: undefined = undefined

  standardPropertyTypesSet(): Set<TStandardPropertyCard> {
    return allStandardPropertyTypes
  }

  standardPropertyTypesNEList(): NEList<TStandardPropertyCard> {
    return createUnsafe([...allStandardPropertyTypes])
  }
}
